import {
    CO_GET_MATERIALSTANDARD_LISTING,
    CO_GET_MATERIALSTANDARD_LISTING_SUCCESS,
    CO_GET_MATERIALSTANDARD_LISTING_FAILED,
  } from "./actionTypes"
  
  const initialState = {
    error: "",
    loading: false,
    materialStandard: null,
  }
  
  const coMaterialStandard = (state = initialState, action) => {
    switch (action.type) {
      case CO_GET_MATERIALSTANDARD_LISTING:
        state = {
          ...state,
          loading: true,
          materialStandard: action.payload,
        }
        break
      case CO_GET_MATERIALSTANDARD_LISTING_SUCCESS:
        state = { ...state, loading: false, materialStandard: action.payload }
        break
      case CO_GET_MATERIALSTANDARD_LISTING_FAILED:
        state = { ...state, loading: false }
        break
      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default coMaterialStandard
  